import { useLayoutEffect } from 'react';

/**
 * While `active`, the page behind a dialog does not scroll: the body's
 * overflow is hidden and put back exactly as it was when the dialog closes.
 * Nested uses are fine, the last one to close restores the first value.
 */
export function useLockBodyScroll(active: boolean): void {
  useLayoutEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;
    const { body } = document;
    const previous = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => { body.style.overflow = previous; };
  }, [active]);
}
